import React from 'react'
import styled from 'styled-components'

const outerBigSize = 64
const outerMediumSize = 56
const outerSmallSize = 48

const innerBigSize = 40
const innerMediumSize = 32
const innerSmallSize = 26

const IconContainer = styled.div<{ backgroundColor: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};

  @media (min-width: 320px) {
    width: ${outerSmallSize}px;
    height: ${outerSmallSize}px;
    border-radius: ${outerSmallSize / 2}px;
  }

  @media (min-width: 768px) {
    width: ${outerMediumSize}px;
    height: ${outerMediumSize}px;
    border-radius: ${outerMediumSize / 2}px;
  }

  @media (min-width: 1024px) {
    width: ${outerBigSize}px;
    height: ${outerBigSize}px;
    border-radius: ${outerBigSize / 2}px;
  }
`

const InnerIconContainer = styled.div<{
  backgroundColor: string
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};

  @media (min-width: 320px) {
    width: ${innerSmallSize}px;
    height: ${innerSmallSize}px;
    border-radius: ${innerSmallSize / 2}px;
  }

  @media (min-width: 768px) {
    width: ${innerMediumSize}px;
    height: ${innerMediumSize}px;
    border-radius: ${innerMediumSize / 2}px;
  }

  @media (min-width: 1024px) {
    width: ${innerBigSize}px;
    height: ${innerBigSize}px;
    border-radius: ${innerBigSize / 2}px;
  }
`
interface ArrowIconProps {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  OuterRingColor: string
  InnerRingColor: string
}

const ArrowIcon = ({
  Icon,
  OuterRingColor,
  InnerRingColor,
}: ArrowIconProps) => {
  return (
    <IconContainer backgroundColor={OuterRingColor}>
      <InnerIconContainer backgroundColor={InnerRingColor}>
        <Icon width={20} height={20} />
      </InnerIconContainer>
    </IconContainer>
  )
}

export default ArrowIcon
